import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Box, Flex, Text } from "@chakra-ui/react";
import { type SplitButtonProps } from "./splitButtonType.props";

export const SpliteButton = ({ direction, text, onClick, textBackGroundColor = "#fff" }: SplitButtonProps) => {
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    const hoverStyle = {
        [`[data-role="${text}-text"]`]: {
            transform: direction ? "translateX(-40%)" : "translateX(40%)",
            color: "#4a4a4a",
        },
        [`[data-role="${text}-box"]`]: {
            borderColor: "#999",
        },
        [`[data-role="${text}-line"]`]: {
            background: "#999",
        },
    };

    return (
        <Flex
            position="relative"
            align="center"
            w={isMobile ? "336px" : "233px"}
            flexDir={direction ? "row-reverse" : "row"}
            cursor="pointer"
            onClick={onClick}
            _hover={hoverStyle}
        >
            <Box data-role={`${text}-line`} width={isMobile ? "229px" : "136px"} height="1px" bg="#cbcbcb" />
            <Box
                data-role={`${text}-box`}
                position="relative"
                w="76px"
                h="82px"
                border="1px solid"
                borderColor="#cbcbcb"
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Text
                    data-role={`${text}-text`}
                    transform={direction ? "translateX(-30%)" : "translateX(30%)"}
                    zIndex="3"
                    background={textBackGroundColor}
                    color="#6b6b6b"
                    transition="all 0.3s ease"
                    {...FONT("notoSerif", 14, 400, 1.4)}
                    h="20px"
                >
                    {text}
                </Text>
            </Box>
        </Flex>
    );
};
